const styles = {
  indicatorsContainer: () => ({
    display: 'none'
  }),
  option: (provided, state) => ({
    ...provided,
    ':active': {
      backgroundColor: 'rgba(255,118,118,0.19)'
    },
    ':hover': {
      backgroundColor: 'rgba(255,118,118,0.19)'
    },
    color: '#dc1845',
    backgroundColor: state.isFocused ? 'rgba(255,118,118,0.19)' : 'white',
    padding: 10
  })
};

export default styles;
